import React from "react";
import { FaFacebookF, FaGithub, FaGoogle, FaLinkedinIn } from "react-icons/fa";

const Footer = () => {
  return (
    <div>
      <footer
        className="text-center text-lg-start text-white"
        style={{ backgroundColor: "#45526e" }}
      >
        <div className="container p-4 pb-0">
          <section className="p-3 pt-0">
            <div className="row d-flex align-items-center">
              <div className="col-md-7 col-lg-8 text-center text-md-start">
                <div className="p-3">
                  <p>Illustrations Used: </p>
                  <small>
                    <a
                      className="text-white text-decoration-none"
                      href="https://storyset.com/technology"
                    >
                      Technology illustrations by Storyset
                    </a>
                  </small>
                  <br />
                  <small>
                    <a
                      className="text-white text-decoration-none"
                      href="https://storyset.com/online"
                    >
                      Online illustrations by Storyset
                    </a>
                  </small>
                </div>
              </div>
              <div className="col-md-5 col-lg-4 ml-lg-0 text-center text-md-end order-lg-last order-first">
                <a
                  className="btn btn-outline-light btn-floating rounded-0"
                  href="https://www.facebook.com/subaktagin.jabir16/"
                  target="_blank"
                  role="button"
                  rel="noreferrer"
                >
                  <FaFacebookF />
                </a>
                <a
                  className="btn btn-outline-light btn-floating rounded-0"
                  target="_blank"
                  href="https://www.linkedin.com/in/ahmad-subaktagin-jabir-5a7a01156/"
                  role="button"
                  rel="noreferrer"
                >
                  <FaLinkedinIn />
                </a>
                <a
                  className="btn btn-outline-light btn-floating rounded-0"
                  target="_blank"
                  href="mailto: ahmad.subaktagin@gmail.com"
                  role="button"
                  rel="noreferrer"
                >
                  <FaGoogle />
                </a>
                <a
                  className="btn btn-outline-light btn-floating rounded-0"
                  target="_blank"
                  href="https://github.com/jabirsubaktagin16"
                  role="button"
                  rel="noreferrer"
                >
                  <FaGithub />
                </a>
              </div>
            </div>
          </section>
        </div>
        <div className="container p-4 pb-0">
          <section className="p-3 pt-0 text-center">
            &copy; {new Date().getFullYear()} Copyright:{" "}
            <a className="text-white text-decoration-none" href="#">
              Ahmad Subaktagin Jabir
            </a>
          </section>
        </div>
      </footer>
    </div>
  );
};

export default Footer;
